export function evseOutletRule(
  message = "Darf nur Buchstaben, Zahlen und das Sonderzeichen * enthalten."
): (value: any) => boolean | string {
  const regex = RegExp(/^[a-zA-Z0-9-*]*$/);
  return (value) => regex.test(value) || message;
}
